export const getOrderByField = (column) => column?.orderByField ?? column?.field;

export const getNextSortModel = (field, sortModel) => {
  const current = sortModel[0];
  if (current?.field !== field) return [{ field, sort: 'asc' }];
  if (current.sort === 'asc') return [{ field, sort: 'desc' }];
  return [];
};

const findColumnByGridField = (columns, gridField) => (
  columns?.find((column) => column.field === gridField)
);

export const sortModelToOrderBy = (givenSortModel, columns = []) => {
  if (!givenSortModel?.length) return '';
  const { field, sort } = givenSortModel[0];
  const column = findColumnByGridField(columns, field);
  const orderByField = getOrderByField(column ?? { field });
  const prefix = sort === 'asc' ? '' : '-';
  return prefix + orderByField;
};

export const orderByToSortModel = (stringOrderBy, columns = [], visibleFields = []) => {
  if (!stringOrderBy) return [];
  const backendField = stringOrderBy?.charAt?.(0) === '-'
    ? stringOrderBy.slice(1)
    : stringOrderBy;
  const sort = stringOrderBy?.charAt?.(0) === '-' ? 'desc' : 'asc';
  if (!backendField.length) return [];

  const matchingColumns = columns.filter(
    (column) => getOrderByField(column) === backendField,
  );

  const visibleColumn = visibleFields?.length
    ? matchingColumns.find((column) => visibleFields.includes(column.field))
    : null;

  const column = visibleColumn ?? matchingColumns[0];
  const gridField = column?.field ?? backendField;

  return [{ sort, field: gridField }];
};
